export default __webpack_public_path__ + "static/media/Banner_North.6a23f93f.jpeg";